import { Typography, FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux";
import {
  getCaseForReviewAction,
  getClaimsTypeAction,
  selectClaimsTypes,
  selectQueueType,
  setClaimsTypeAction,
} from "./QueueSlice";

interface ClaimsTypesProps {
  handleClose(): void;
}

export function ClaimsTypes(props: ClaimsTypesProps) {
  const { handleClose } = props;
  const types = useAppSelector(selectClaimsTypes);
  const dispatch = useAppDispatch();
  const queueType = useAppSelector(selectQueueType);
  const [claimType, setClaimsType] = useState<string>("");

  useEffect(() => {
    const start = async () => {
      async function getData() {
        if (queueType) {
          const _queueType = queueType === "paneem" ? queueType : "SP";
          await dispatch(getClaimsTypeAction(_queueType));
        }
      }

      await getData();
    };

    start();
  }, [queueType]);

  const startQueue = async (type: string) => {
    if (!queueType) {
      return;
    }
    const _queueType = queueType === "paneem" ? queueType : "SP";

    const args = {
      queueType: _queueType,
      claimType: type,
      userInfoId: null,
      regNum: null,
    };
    await dispatch(getCaseForReviewAction(args));
  };

  if (types && types.length) {
    return (
      <FormControl variant="outlined" sx={{ textAlign: "center", width: "100%" }}>
        <InputLabel
          sx={{
            color: "#000",
            "&.Mui-focused": { color: "#3F51B5" },
          }}
        >
          Please select a claims type
        </InputLabel>
        <Select
          value={claimType}
          onChange={async (e) => {
            dispatch(setClaimsTypeAction(e.target.value));
            await startQueue(e.target.value);
            handleClose();
          }}
          sx={{ textAlign: "center", width: "100%" }}
          label="Please select a claims type"
        >
          {types && types.length
            ? types.map((type, i) => (
                <MenuItem value={type} key={i}>
                  {type.toUpperCase()}
                </MenuItem>
              ))
            : null}
        </Select>
      </FormControl>
    );
  } else {
    return (
      <Typography variant="h3" textAlign={"center"}>
        The Queue is Empty
      </Typography>
    );
  }
}
